export enum StepId {
  Address = 'ADDRESS',
  ConfirmAddress = 'CONFIRM_ADDRESS',
  HomeOrLandSale = 'HOME_OR_LAND_SALE',
  HomeSale = 'HOME_SALE',
  LandSale = 'LAND_SALE',
  Condition = 'CONDITION',
  OccupancyStatus = 'OCCUPANCY_STATUS',
  OccupancyDescription = 'OCCUPANCY_DESCRIPTION',
  Mortgage = 'MORTGAGE',
  PriceRange = 'PRICE_RANGE',
  RelationToProperty = 'RELATION_TO_PROPERTY',
  Urgency = 'URGENCY',
  ContactInformation = 'CONTACT_INFORMATION',
  Authentication = 'AUTHENTICATION',
  MultipleProperties = 'MULTIPLE_PROPERTIES',
  ThankYou = 'THANK_YOU',
  NewContactInformationDesign = 'NEW_CONTACT_INFORMATION_DESIGN',
  IntentSelector = 'INTENT_SELECTOR',
  AgentOrHomeowner = 'AGENT_OR_HOMEOWNER',
  AgentInformation = 'AGENT_INFORMATION',
  PasswordlessSignup = 'PASSWORDLESS_SIGNUP',
  WelcomeBack = 'WELCOME_BACK',
}

export enum SaleTimeline {
  Immediately = 'IMMEDIATELY',
  ThreeMonths = '3_MONTHS',
  ThreeToSixMonths = '3_TO_6_MONTHS',
  SixPlusMonths = 'PLUS_6_MONTHS',
}

export type NextStepData = {
  answer: Record<string, any>
  featureFlags: Record<string, any>
}
export interface Transition {
  field?: string
  operator?: 'equals' | 'not_equals' | 'contains' | 'exists' | 'not_exists'
  value?: any
  default?: boolean
  nextStepId: StepId
}

export interface WorkflowStep {
  id: string
  name?: string
  transitions: Transition[]
}
